import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {MESSAGE, EDIT_MODE, STATUS_NAME} from "../../../../../wpconfig"
import * as func from "../../../../../utils/functions";

import * as Actions from "../../../../../store/modules/resources";
import * as FActions from "../../../../../store/modules/footer";

import AuthorityPopup from "./AuthorityPopup";
import AuthorPopup from "./AuthorPopup";
// import AgencyDataPopup from '../../popup/agencyData';

import Item from './item'
import ReactPaginate from "react-paginate";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";

class AuthorForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			param: {
				'org' : '',
				'record_per_page': 20,
				'current_page': 1
			},
			records: [],
			// totalRecords: 0,
			totalPage : 0,
			isInit: false,
			// records: [],
			categoryType: ['author_role', 'sinbun_type', 'position_type', 'country'],
			author_role: [],
			author_role_Name: [],
			sinbun_type: [],
			sinbun_type_Name: [],
			position_type: [],
			position_type_Name: [],
			country: [],
			country_Name: [],
			editIndex: '',
			pkKey: 'author_id',
			showAuthorityPopup: false,
			showAuthorPopup: false,
			searchPopupIndex: '',
			searchPopupTitle: '',
			dept: [],
			dept_depth1: [],
			dept_depth2: [],
			dept_depth3: [],
			original_wos_resource : {},
			checkedRecords : [],
			selectCountry : ''
		}
	}

	componentDidMount() {
		func.getData("admin/resource/" + func.getParams("record_id") + "/author", this.state.param).then((response) => {
			if (response.records) {
				this.setState({
					isInit: true,
					// totalRecords : response.pageInfo.totalResults,
					totalPage : response.pageInfo.totalPage,
					records: response.records
				});
			} else {
				this.setState({
					isInit: true,
				});
			}
		});

		func.getData("category/dept", null).then((response) => {
			this.setState({dept: response.records})
		})

		this.state.categoryType.map((type, idx) => {
			func.getData("code/search/" + type, {}).then((response) => {
				const t = {}
				t[type] = response.records;
				t[type + "_Name"] = {}
				response.records.map((r, i) => {
					t[type + "_Name"][r.code_id] = r.code_name;
				});
				this.setState(t);
			});
		})

		if(this.props.record.wos_id) {
			func.getData("admin/resource/original_wos_resource/" + this.props.record.wos_id, null).then((response) => {
				let original_wos_resource = {}
				if (response.record) {
					original_wos_resource = response.record._source;
				}
				this.setState({original_wos_resource:original_wos_resource})
			});
		}

		this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);
		this.showMessage = this.showMessage.bind(this);
		this.setAuthority = this.setAuthority.bind(this);
		this.setAuthorityPopup = this.setAuthorityPopup.bind(this);
		this.setAuthor = this.setAuthor.bind(this);
		this.setAuthorPopup = this.setAuthorPopup.bind(this);
		this.author_batch = this.author_batch.bind(this);
		this.author_batch_coauthor = this.author_batch_coauthor.bind(this);
		this.author_batch_confirm = this.author_batch_confirm.bind(this);
		this.getData = this.getData.bind(this);
		this.onAuthorBulkChangeOrg = this.onAuthorBulkChangeOrg.bind(this);
	}

	onInsert() {
		const record = this.state.records;

		if (record.length > 0 && record[0][this.state.pkKey] === '') {
			this.showMessage('추가해주세요.')
		} else {
			const insertRecord = {
				"author_id": "",
				"author_order": "",
				"author_name": "",
				"author_abbr_name": "",
				"author_full_name": "",
				"org_name": "",
				"org_id": "",
				"author_role": "",
				"authority_id": "",
				"scholar_id": "",
				"sinbun_name": "",
				"sinbun_code": "",
				"mou": "",
				"mou_code": "",
				"worker_id": "",
				"author_status": "publish",
				"is_edit": EDIT_MODE.SHOW_EDIT,
			}
			this.onEditIndex(0);
			// 데이터 변환 체크하기
			record.unshift(insertRecord)
			this.setState({records: record})
		}
	}

	onUpdate(index, item, render) {
		const record = this.state.records
		record[index] = item
		this.setState({records: record})
		if (render)
			this.forceUpdate();
	}

	onRemove(index) {
		const record = this.state.records
		record.splice(index, 1);
		this.setState({records: record})
		this.forceUpdate();
	}

	onEditIndex(id) {
		if (this.state.editIndex && this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();
		else if (this.refs.ref)
			this.refs.ref.onClose();
		else if (this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex': id
		})
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	setAuthorityPopup(status, searchPopupIndex, ks) {
		if (status) {
			this.setState({
				showAuthorityPopup: status,
				searchPopupIndex: searchPopupIndex,
				searchPopupTitle: ks ? ks : ''
			})
		} else {
			this.setState({
				showAuthorityPopup: status,
				searchPopupIndex: searchPopupIndex,
			})
		}
	}

	setAuthority(record) {
		this.setAuthorityPopup(false, 0);
		let r = this.state.records[this.state.searchPopupIndex];
		r.org_id = record.authority_id;
		r.org_name = record.authority_term;
		r.mou = record.mou;
		r.mou_code = record.mou_code;
		// console.log(r)
		// console.log(record)
		let records = this.state.records;
		records[this.state.searchPopupIndex] = r;
		this.setState({records: records});
	}

	setAuthorPopup(status, searchPopupIndex, ks) {
		if (status) {
			this.setState({
				showAuthorPopup: status,
				searchPopupIndex: searchPopupIndex,
				searchPopupTitle: ks ? ks : ''
			})
		} else {
			this.setState({
				showAuthorPopup: status,
				searchPopupIndex: searchPopupIndex,
			})
		}
	}

	setAuthor(record, index) {
		this.setAuthorPopup(false, 0);
		let r = index != null ? this.state.records[index] : this.state.records[this.state.searchPopupIndex];

		r.scholar_id = record.scholar_id;
		r.author_name = record.author_name ? record.author_name : record.scholar_name;
		r.school_no = record.school_no;
		r.sinbun_code = record.sinbun_code;
		r.sinbun_name = record.sinbun_name;
		r.org_id = record.org_id ? record.org_id : rmVars.org_id;
		r.org_name = record.org_name ? record.org_name : rmVars.org_name;
		r.col_id = record.col_id;
		r.col_name = record.col_name;
		r.dept_id = record.dept_id;
		r.dept_name = record.dept_name;
		r.maj_id = record.maj_id ? record.maj_id : 0;
		r.maj_name = record.maj_name;
		r.email = record.email;
		r.mou = record.mou;
		r.mou_code = record.mou_code;

		let records = this.state.records;
		records[this.state.searchPopupIndex] = r;

		this.setState({
			records: records,
		});

		this.refs["ref" + r[this.state.pkKey]].setDepth();
		this.forceUpdate();
	}

	onChange = (event) => {
		let state = this.state
		state[event.target.name] = event.target.value
		this.setState(state)
		this.forceUpdate()
	};

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.state.param;
		param['current_page'] = paged;

		func.getData("admin/resource/" + func.getParams("record_id") + "/author", param).then((response) => {
			this.setState({
				param: param,
				totalPage : response.pageInfo.totalPage,
				records: response.records
			});
		});
	}

	author_batch = (event) => {
		event.preventDefault()

		alert('준비중입니다.')
	}

	author_batch_coauthor = (event) => {
		event.preventDefault()

		func.updateData("admin/resource/" + func.getParams("record_id") + "/author_batch_coauthor", []).then((response) => {
			func.getData("admin/resource/" + func.getParams("record_id") + "/author", this.state.param).then((response) => {
				if (response.records) {
					this.setState({
						totalPage : response.pageInfo.totalPage,
						records: response.records
					});
				}
			});
		})
	}

	author_batch_confirm = (event) => {
		event.preventDefault()

		func.updateData("admin/resource/" + func.getParams("record_id") + "/author_batch_confirm", []).then((response) => {
			func.getData("admin/resource/" + func.getParams("record_id") + "/author", this.state.param).then((response) => {
				if (response.records) {
					this.setState({
						totalPage : response.pageInfo.totalPage,
						records: response.records
					});
				}
			});
		})
	}

	getData = (org) => {
		event.preventDefault()

		let param = this.state.param
		param['org'] = org ? org : ''

		func.getData("admin/resource/" + func.getParams("record_id") + "/author", param).then((response) => {
			if (response.records) {
				this.setState({
					param : param,
					totalPage : response.pageInfo.totalPage,
					records: response.records,
					checkedRecords : [],
				});
			} else {
				this.setState({
					checkedRecords : [],
					param : param,
				});
			}
		});
	}

	onRecordCheck = () => {
		const checkedRecords = this.state.checkedRecords;
		if (event.target.checked) {
			checkedRecords.push(''+event.target.value)
			this.setState({checkedRecords : checkedRecords});
		} else {
			const idx = checkedRecords.indexOf(event.target.value)
			if (idx > -1) checkedRecords.splice(idx, 1)
			this.setState({checkedRecords : checkedRecords});
		}
		this.forceUpdate()
	}

	compareArray = function(a, b){
		if(JSON.stringify(a) === JSON.stringify(b)) {
			return true;
		} else{ return false; }
	}

	isAllChecked () {
		let recordsId = [];
		this.state.records.map((record, index) => {
			recordsId.push(''+record.author_id)
		})
		let checkedRecordsId = this.state.checkedRecords;

		let nameSort = function(a,b){
			if(a < b){
				return -1
			}else if(a > b){
				return 1;
			}else{
				return 0;
			}
		}

		recordsId.sort(nameSort);
		checkedRecordsId.sort(nameSort);

		return this.compareArray(recordsId, checkedRecordsId)
	}

	onAllRecordCheck = () => {
		const checkedRecords = [];
		if (event.target.checked) {
			{this.state.records.map((record, index) => {
				checkedRecords.push(''+record.author_id)
			})}
		}
		this.setState({checkedRecords : checkedRecords});
		this.forceUpdate()
	}

	onBulkChangeCountry = () => {
		event.preventDefault()

		let param = {}
		param.author_ids = []
		this.state.records.map((record, idx) => {
			if (this.state.checkedRecords.includes('' + record.author_id)) {
				param.author_ids.push(record.author_id)
			}
		})
		param.country = this.state.selectCountry

		func.updateData("admin/resource/" + func.getParams("record_id") + "/author_bulk_change_country", param).then((response) => {
			func.getData("admin/resource/" + func.getParams("record_id") + "/author", this.state.param).then((response) => {
				if (response.records) {
					this.setState({
						totalPage : response.pageInfo.totalPage,
						records: response.records
					});
				}
			});
		});
	}

	onAuthorBulkChangeOrg = (record) => {
		if(this.state.checkedRecords.length > 1) {
			let author = []
			this.state.records.map((r, idx) => {
				if (this.state.checkedRecords.includes('' + r.author_id)){
					author.push({
						'author_id' : r.author_id,
						'author_status' : r.author_status,
					})
				}
			})

			let param = {
				org_id : record.org_id,
				org_name : record.org_name,
				author_status : record.author_status,
				author : author
			}

			func.updateData("admin/resource/" + func.getParams("record_id") + "/author_bulk_change_org", param).then((response) => {
				func.getData("admin/resource/" + func.getParams("record_id") + "/author", this.state.param).then((response) => {
					if (response.records) {
						this.setState({
							totalPage : response.pageInfo.totalPage,
							records: response.records
						});
						this.forceUpdate();
					}
				});
			})
		} else {
			// alert('하나 이상 선택해주세요.')
		}
	}

	render() {
		const {records} = this.state
		const allChecked = this.isAllChecked()
		let isChecked = false
		records.map((record, idx) => {
			if (this.state.checkedRecords.includes('' + record.author_id)){
				isChecked = true
				return
			}
		})

		return (
			<>
				<div className="d-flex justify-content-end mb-1">
					<h5 className="flex-grow-1 font-weight-bold align-bottom mt-3 mb-1">저자 관리</h5>
					<button type="button" className="btn btn-sm btn-primary" style={{"margin": "10px", "marginRight": "0px"}}
					        onClick={this.onInsert}>추가
					</button>
				</div>
				<div className="d-flex mb-2">
					<div className="pr-1">
						<div className="btn-group">
							<button className={"btn btn-outline-dark btn-sm view-all-authors" +
											( this.state.param.org === '' ? ' active' : '')} onClick={()=>this.getData('')}>전체</button>
							<button className={"btn btn-outline-dark btn-sm view-org-authors" +
											( this.state.param.org === 'local' ? ' active' : '')} onClick={()=>this.getData('local')}>기관소속</button>
							<button className={"btn btn-outline-dark btn-sm view-not-country" +
											( this.state.param.org === 'nocountry' ? ' active' : '')} onClick={()=>this.getData('nocountry')}>국가미배정</button>
							<button className={"btn btn-outline-dark btn-sm view-email" +
											( this.state.param.org === 'email' ? ' active' : '')} onClick={()=>this.getData('email')}>이메일</button>
							<button className={"btn btn-outline-dark btn-sm view-correspond" +
											( this.state.param.org === 'correspond' ? ' active' : '')} onClick={()=>this.getData('correspond')}>교신저자</button>
							<button className={"btn btn-outline-dark btn-sm view-ext-author-link" +
											( this.state.param.org === 'extauthorlink' ? ' active' : '')} onClick={()=>this.getData('extauthorlink')}>타기관저자연결</button>
						</div>
					</div>
					{isChecked &&
					<div className="pl-2 pr-1 check-view">
						<div className="">
							<select className="form-control d-inline-block mr-1"
							        onChange={this.onChange}
							        name="selectCountry"
							        // ref={(ref)=>this.selectCountry=ref}
							        style={{width: "100px", height: '32px'}}>
								<option value="">국가변경</option>
								{this.state.country && this.state.country.map((type, i) => {
									return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
								})}
							</select>
							<button name="" onClick={this.onBulkChangeCountry} value=""
							        className="btn btn-outline-secondary btn-sm bulk-change-country mr-1">변경
							</button>
						</div>
					</div>
					}
					<div className="ml-auto">
						<div className="btn-group">
							<button className="btn btn-outline-dark btn-sm act-all-author-inspect" onClick={this.author_batch}>일괄검증</button>
							<button className="btn btn-outline-dark btn-sm act-all-role-coauthor" onClick={this.author_batch_coauthor}>공동저자 일괄처리</button>
							<button className="btn btn-outline-dark btn-sm act-all-publish" onClick={this.author_batch_confirm}>완료 일괄처리</button>
						</div>
					</div>
				</div>
				<table className="xwp-list-table xwidefat xfixed xstriped table-thin table border-bottom rm-resource-author">
					<thead>
					<tr>
						<th scope="col">
							<input type="checkbox" className="ml-0"
							       checked={allChecked}
                     onChange={this.onAllRecordCheck}
							/>
						</th>
						<th scope="col">NO</th>
						<th scope="col">저자</th>
						<th scope="col">신분</th>
						<th scope="col">역할</th>
						<th scope="col">소속기관</th>
						<th scope="col">단대 / 학과 / 전공</th>
						<th scope="col">국가</th>
						<th scope="col">Email</th>
						<th scope="col">상태</th>
						<th scope="col">Actions</th>
					</tr>
					</thead>
					<tbody>
					{
						records && this.state.dept.length > 0 &&
						records.map((record, idx) => {
							const checked = this.state.checkedRecords.includes(''+record.author_id)
							return (
								<Item
									key={record[this.state.pkKey]}
									index={record[this.state.pkKey]}
									ref={"ref" + record[this.state.pkKey]}
									pkKey={this.state.pkKey}
									arrIndex={idx}
									record={record}
									dept={this.state.dept}
									author_role={this.state.author_role}
									author_role_Name={this.state.author_role_Name}
									sinbun_type={this.state.sinbun_type}
									sinbun_type_Name={this.state.sinbun_type_Name}
									country={this.state.country}
									country_Name={this.state.country_Name}
									onUpdate={this.onUpdate}
									onRemove={this.onRemove}
									onEditIndex={this.onEditIndex}
									showMessage={this.showMessage}
									setAuthor={this.setAuthor}
									setAuthorPopup={this.setAuthorPopup}
									setAuthorityPopup={this.setAuthorityPopup}
									onRecordCheck={this.onRecordCheck}
									checked={checked}
									onAuthorBulkChangeOrg={this.onAuthorBulkChangeOrg}
								/>
							)
						})
					}
					</tbody>
				</table>

				{this.state.totalPage > 1 &&
				<div className="mt-4">
					<div>
						<div className="paging-wrap">
							<ReactPaginate
								forcePage={Number(this.state.param.current_page) - 1}
								pageCount={this.state.totalPage}
								marginPagesDisplayed={2}
								pageRangeDisplayed={2}
								onPageChange={this.handlePageClick}
								containerClassName={'pagination'}
								activeClassName={'active'}
								pageClassName={'page-item'}
								pageLinkClassName={'page-link'}
								previousClassName={'page-item page-item-prev'}
								previousLinkClassName={'page-link'}
								nextClassName={'page-item page-item-next'}
								nextLinkClassName={'page-link'}
							/>
						</div>
					</div>
				</div>
				}

				{this.state.original_wos_resource.original &&
				<div className="row mt-4">
					<div className="col-md-12">
						<div className="bd-callout bd-callout-warning border p-2 bg-light">
							<h5>Web of Science Original Resource</h5>
							<h6 className="mt-2 mb-0">ORCID</h6>
							<p className="m-0">{this.state.original_wos_resource.original['ORCIDs']}</p>
							<h6 className="mt-2 mb-0">Reprint</h6>
							<p className="m-0">{this.state.original_wos_resource.original['Reprint Addresses']}</p>
							<h6 className="mt-2 mb-0">Email Address</h6>
							<p className="m-0">{this.state.original_wos_resource.original['Email Addresses']}</p>
						</div>
					</div>
				</div>
				}

				{this.state.showAuthorityPopup &&
				<AuthorityPopup
					showAuthorityPopup={this.state.showAuthorityPopup}
					ks={this.state.searchPopupTitle}
					set={this.setAuthority}
					showMessage={this.showMessage}
					setAuthorityPopup={this.setAuthorityPopup}
				/>
				}

				{this.state.showAuthorPopup &&
				<AuthorPopup
					showAuthorPopup={this.state.showAuthorPopup}
					ks={this.state.searchPopupTitle}
					set={this.setAuthor}
					showMessage={this.showMessage}
					setAuthorPopup={this.setAuthorPopup}
				/>
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.resources.record ? state.resources.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(AuthorForm)
